import { useMemo } from 'react'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { AtendimentoGestaoExpandedRow } from './columns/AtendimentoGestaoExpandedRow'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { atendimentoGestaoColumns } from './columns/_columns'
import { AtendimentoGestao } from '../core/_models'
import { useT } from '_metronic/i18n/Metronici18n'

export const AtendimentoGestaoTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { hasFilters, clearFilters } = useListFilters()
  const { t } = useT()

  const columns = useMemo(() => atendimentoGestaoColumns(t), [t])

  const emptyState = hasFilters ? (
    <TableEmptyState
      title='Nenhum atendimento encontrado'
      description='Revise o período e os filtros aplicados.'
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      title='Nenhum atendimento para exibir'
      description='Informe um período para consultar os atendimentos.'
    />
  )

  return (
    <CustomTable<AtendimentoGestao>
      id='kt_table_atendimentos_gestao'
      ariaLabel='Gestão de atendimentos'
      itemLabel={{ singular: 'atendimento', plural: 'atendimentos' }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      queryHooks={{ useQueryRequest, useQueryResponse }}
      // Os detalhes (linha do tempo e tempos) já vêm na própria linha.
      enableExpand
      onExpandFetch={async (row) => row.original}
      getExpandLabel={(row) => row.paciente?.pessoa?.nome || row.paciente?.nome || row.protocolo}
      renderExpand={(data, loading) => (
        <AtendimentoGestaoExpandedRow
          isLoading={loading}
          atendimento={data as AtendimentoGestao | undefined}
        />
      )}
    />
  )
}
